import type { SchemaField } from '@cli-types/core-engine/schema.js'
import type { FieldRenderContext } from '@cli-types/next-adapter/forms.js'
import { formItemProps } from '@next-adapter/generators/form/form-shared/form-item-props.js'
import { formLabel } from '@next-adapter/generators/form/form-shared/form-label.js'
import { labelWithDescription } from '@next-adapter/generators/form/form-shared/label-with-description.js'
import { renderDefaultValueChangeHandler } from '@next-adapter/templates/renderers/generators/form/field-jsx/render-default-value-change-handler.js'
import { renderGalleryFieldFormFieldTemplate } from '@next-adapter/templates/renderers/generators/form/field-jsx/render-gallery-field.js'
import { defaultValueFromSourceHandler } from './default-value-from-source-handler.js'

export function renderGalleryField(
  field: SchemaField,
  indent: string,
  label: string,
  hintJSX: string,
  context: FieldRenderContext
): string {
  const maxItemsProp = field.maxItems ? `\n${indent}          maxItems={${field.maxItems}}` : ''
  const defaultValueFromHandler = defaultValueFromSourceHandler(field, context)
  const onChange = defaultValueFromHandler
    ? renderDefaultValueChangeHandler({
        indent: indent,
        defaultValueFromHandler: defaultValueFromHandler
      })
    : 'formField.onChange'
  return renderGalleryFieldFormFieldTemplate({
    indent: indent,
    fieldName: field.name,
    formItemProps: formItemProps(field),
    labelWithDescription: labelWithDescription(formLabel(field, label), hintJSX, `${indent}      `),
    onChange: onChange,
    maxItemsProp: maxItemsProp
  })
}
